import legacyClasses from '../js/legacyClasses'

export default {
  install: function (Vue) {
    Vue.prototype.$classes = function () {
      return {
        async classList () {
          // legacy classes
          let classList = legacyClasses
          Object.keys(classList).forEach(key => classList[key].isFirestore = false)
          // grab classes in firestore and sort by date_start
          const firestoreClasses = (await Vue.prototype.$firestore.collection('classes').get()).docs
          .map(doc => doc.data())
          .sort((a,b) => new Date(a.date_start).getTime() - new Date(b.date_start).getTime())

          // add to classList
          firestoreClasses.forEach(aClass => classList[aClass.id] = {
            ... aClass,
            isFirestore: true 
          })
          // return
          return classList
        }
      }
    }
  }
}